<template>
<div class="chapter">
<div class="inner_page">
<p class="head">Contents</p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">Chapter 1. The History of the Duke City</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">Chapter 2. The Bottger Mansion</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">Chapter 3. La Placita Restaurant: Casa de Armijo</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">Chapter 4. La Piñata</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">Chapter 5. The Blueher Mansion</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">Chapter 6. The Blueher Barn</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">Chapter 7. The Garcia House (Café Au Lait)</span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample">Chapter 8. The Church Street Café: Casa de Ruiz</span></p>
<p class="toc"><span href="#/chapter9" title="Link target outside of Sample">Chapter 9. Sarge, the Confederate Ghost</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Chapter 10. La Capilla de Nuestra Senora de Guadalupe Chapel</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Chapter 11. The High Noon Restaurant</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Chapter 12. Alfredo’s Coffee Shop</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Chapter 13. The Salvador Armijo House</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">Chapter 14. Albuquerque Job Corps Center</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">Chapter 15. Las Mañanitas</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">Chapter 16. Julia’s New Mexican and Vegetarian Café</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">Chapter 17. The Manuel Springer House</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">Chapter 18. Casa de Fiesta Restaurant: The Cristobal Armijo House</span></p>
<p class="toc1"><span href="#/afterword" title="Link target outside of Sample">Afterword</span></p>
<p class="toc"><span href="#/references" title="Link target outside of Sample">References</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8ae8482e